import React, { useEffect, useRef } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { jornadaStore } from "../../data/jornadaStore";
import { useNetwork } from "../../hooks/useNetwork";
import { Header } from "./Header";
import { AppShell } from "../appShell";
import { NavigationBar } from "./Nav";
import { Footer } from "../Footer";
import { ToastProvider } from "../toastProvide";

export const PrivateLayout = () => {
  const { auth, loading } = useAuth();
  const location = useLocation();
  const bootstrappedRef = useRef(false);

  useNetwork((isOnline) => jornadaStore.setOnline(isOnline));

  useEffect(() => {
    if (!auth?.id) return;
    if (bootstrappedRef.current) return;
    bootstrappedRef.current = true;

    jornadaStore.setOnline(navigator.onLine);
    jornadaStore.bootstrap().catch((e) => {
      console.warn("[PrivateLayout] bootstrap jornadaStore:", e?.message);
    });
  }, [auth?.id]);

  if (loading) return <div>Cargando...</div>;
  if (!auth?.id) return <Navigate to="/" replace />;
  if (location.pathname === "/app") return <Navigate to="/app/inicio" replace />;

  return (
    <ToastProvider>
      <AppShell
        header={<Header />}
        nav={<NavigationBar />}
        footer={<Footer />}
      >
        <Outlet />
      </AppShell>
    </ToastProvider>
  );
};
